import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenCreateAction from './communityGardenCreate.action.json' with { type: 'json' }
import { communityGardenObject } from '../communityGardenObject'

const communityGardenCreateDefinition = defineAction({
  ...communityGardenCreateAction,

  input: communityGardenObject
    .pick({
      id: true,
      title: true,
      address: true,
      latitude: true,
      longitude: true,
      observation: true,
      area: true,
      bedsCount: true,
      createdAt: true,
      updatedAt: true,
    })
    .extend({ id: communityGardenObject.shape.id.nullish() }),
  output: z.object({ id: communityGardenObject.shape.id }),
})

export default communityGardenCreateDefinition
